// Auto-generated normalizer for table: CAR_BOOKING.ChoferVehiculoAsignacion
export function choferVehiculoAsignacionNormalize(row) {
  return {
    idAsignacion: row.idAsignacion ?? row.IdAsignacion ?? row['idAsignacion'] ?? 0,
    idChofer: row.idChofer ?? row.IdChofer ?? row['idChofer'] ?? 0,
    idVehiculo: row.idVehiculo ?? row.IdVehiculo ?? row['idVehiculo'] ?? 0,
    fechaDesde: row.fechaDesde ?? row.FechaDesde ?? row['fechaDesde'] ?? null,
    fechaHasta: row.fechaHasta ?? row.FechaHasta ?? row['fechaHasta'] ?? null,
    comentarios: row.comentarios ?? row.Comentarios ?? row['comentarios'] ?? '',
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['fechaCreacion'] ?? null,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}